<template>
    <div>
        <button
            @click="addItem"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah PPHPTender
        </button>
        <div
            v-for="(pphptender, pphptenderIndex) in itemList"
            :key="pphptender.pphptenderUniqueId || pphptenderIndex"
            class="pphptender-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="itemList[pphptenderIndex].id"
                        :options="getOptionsForDropdown(pphptenderIndex)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="(event) => fetchOptionsForDropdown(event, pphptenderIndex, apiEndpoint)"
                        @change="() => validateUniqueness(pphptenderIndex, 'PPHPTender')"
                        placeholder="Pilih Panitia Penerima Hasil Perkerjaan"
                    />
                    <button
                        @click="removeItem(pphptenderIndex)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import MultiSelectDropdownMixin from "@/mixins/MultiSelectDropdownMixin.js";

export default defineComponent({
    components: {
        Dropdown,
    },
    mixins: [MultiSelectDropdownMixin],
    props: {
        list_pphptender: Array,
        pphptender_id: String,
    },
    data() {
        // Initialize item list using mixin helper
        const pphptenderInitialList = this.initializeItemList(
            this.list_pphptender,
            'pphptenderUniqueId',
            'pphptenderDisplayIndex'
        );
        
        return {
            // Component-specific configuration
            uniqueIdField: 'pphptenderUniqueId',
            displayIndexField: 'pphptenderDisplayIndex',
            apiEndpoint: '/organisasi_pengadaan/search_pphp',
            
            // Item list management
            itemList: pphptenderInitialList,
            nextIndex: this.calculateNextIndex(pphptenderInitialList, 'pphptenderDisplayIndex'),
        };
    },
    watch: {
        list_pphptender: {
            handler(newValue) {
                if (newValue) {
                    // Block recursive updates
                    if (this._internalUpdate) return;
                    
                    this.itemList = this.initializeItemList(
                        newValue,
                        this.uniqueIdField,
                        this.displayIndexField
                    );
                    
                    this.nextIndex = this.calculateNextIndex(this.itemList, this.displayIndexField);
                    this.updateSelectedItemsCache();
                } else {
                    this.itemList = [];
                    this.nextIndex = 1;
                    this.selectedItemsCache.clear();
                }
            },
            deep: true,
        },
        itemList: {
            handler(newValue) {
                // Prevent recursive updates
                this._internalUpdate = true;
                this.$emit("update:list_pphptender", newValue);
                this.updateSelectedItemsCache();
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.initializeOptions(this.apiEndpoint);
    },
});
</script>
